import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
    campoItemDescripcion: {
        width: '200px',
    },
});

export default useStyles;
